import { Router } from './router';
export * from './link';
export * from './redirect';
export * from './parseroute';
export * from './route';
export * from './switch';
export var HistoryRouter = Router;
export { Location } from './router';
